import styled from 'styled-components';
import { query, font, color, space } from '@design/templateFns';
import Block from '@components/Layout/Block';

export const StyledBlock = styled(Block)`
  border-top: 1px solid ${color('gray2')};
`;

export const ImageWrapper = styled.div`
  width: 100%;
  height: auto;
  max-width: 220px;
  margin: 0 auto ${space('x6')};

  @media screen and (${query.atLeast('desktop')}) {
    margin-bottom: ${space('x7')};
  }
`;

export const Header = styled.h2`
  ${font('headline-sm')};
  text-align: center;
  padding-bottom: ${space('lg')};

  @media screen and (${query.atLeast('desktop')}) {
    ${font('headline-lg')};
  }
`;

export const Subheader = styled.span`
  ${font('subhead-xs')};
  text-align: center;
  padding-bottom: 0;

  @media screen and (${query.atLeast('desktop')}) {
    ${font('subhead-sm')};
  }
`;

export const SubheaderWrapper = styled.h3`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: ${space('md')};
  text-align: center;

  .with-bullet:after {
    content: '';
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 6px;
    margin-left: 13px;
    background-color: ${color('gray2')};
  }
`;
